import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { MODAL_TYPES } from "../../types/modal-types";

export type ModalType = keyof typeof MODAL_TYPES | string;

interface ModalStore<T = any> {
  type: ModalType | null;
  data: T | null;
  loading: boolean;
  
  open: (type: ModalType, data?: T) => void;
  close: () => void;
  updateData: (data: T) => void;
  setLoading: (loading: boolean) => void;
}

export const useModalStore = create<ModalStore>()(
  devtools((set) => ({
    type: null,
    data: null,
    loading: false,

    open: (type, data = null) => {
      set({ type, data, loading: false });
    },

    close: () => {
      set({ type: null, data: null, loading: false });
    },

    updateData: (data) => {
      set({ data });
    },

    setLoading: (loading) => {
      set({ loading });
    },
  }))
);
